/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoodsInfoForKoreaReturnVo
 */
export interface GoodsInfoForKoreaReturnVo {
    /**
     * 商品id
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    id?: number;
    /**
     * skuId
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    skuId?: number;
    /**
     * 商品名称
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    name?: string;
    /**
     * 商品单价
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    unitPrice?: number;
    /**
     * 商品总价
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    totalPriceKrw?: number;
    /**
     * 商品总价(美元)
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    totalPriceUsd?: number;
    /**
     * 商品链接  没有就用空字符串
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    url?: string;
    /**
     * 商品图片链接
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    imgUrl?: string;
    /**
     * 颜色
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    size?: string;
    /**
     * 原产地
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    origin?: string;
    /**
     * 品牌
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    brand?: string;
    /**
     * 市场条码
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    marketBarcode?: string;
    /**
     * 市场商品名称
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    marketProNm?: string;
    /**
     * 市场选项名称
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    marketOptionName?: string;
    /**
     * 市场选项ID
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    marketOptionId?: string;
    /**
     * 市场到期日期
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    marketExpiryDate?: string;
    /**
     * CO商品名称（英文）
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    coGoodsNameEn?: string;
    /**
     * CO海关编码
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    coHsCode?: string;
    /**
     * 是否为合包商品 0 不是，1 是  （0是基础商品，1 是合包商品）
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    combined?: number;
    /**
     * 商品来源  1 普通url下单， 2 sku下单， 3 库存下单， 4 复制购物车
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    sourceType?: number;
    /**
     * 商品初始数量  分单的时候，要是分商品，那商品可用数量和初始数量都要减
     * 商品初始数量
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    initQuantity?: number;
    /**
     * 如果本条记录是基础商品，且是sku下单，那么这里有值
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    skuProductId?: number;
    /**
     * 用户id
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    userId?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    code?: string;
    /**
     * 购买商品的所在平台的url
     * @type {string}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    purchasePlatformUrl?: string;
    /**
     * 合包商品id
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    parentGoodsId?: number;
    /**
     * 商品总价(人民币)
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    totalPriceCny?: number;
    /**
     * 通关类目id
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    ctmsItemId?: number;
    /**
     * 构成
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    constructCount?: number;
    /**
     * 商品购买平台id
     * @type {number}
     * @memberof GoodsInfoForKoreaReturnVo
     */
    businessPlatformId?: number;
}

/**
 * Check if a given object implements the GoodsInfoForKoreaReturnVo interface.
 */
export function instanceOfGoodsInfoForKoreaReturnVo(value: object): value is GoodsInfoForKoreaReturnVo {
    return true;
}

export function GoodsInfoForKoreaReturnVoFromJSON(json: any): GoodsInfoForKoreaReturnVo {
    return GoodsInfoForKoreaReturnVoFromJSONTyped(json, false);
}

export function GoodsInfoForKoreaReturnVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoodsInfoForKoreaReturnVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'name': json['name'] == null ? undefined : json['name'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'totalPriceKrw': json['totalPriceKrw'] == null ? undefined : json['totalPriceKrw'],
        'totalPriceUsd': json['totalPriceUsd'] == null ? undefined : json['totalPriceUsd'],
        'url': json['url'] == null ? undefined : json['url'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'marketExpiryDate': json['marketExpiryDate'] == null ? undefined : json['marketExpiryDate'],
        'coGoodsNameEn': json['coGoodsNameEn'] == null ? undefined : json['coGoodsNameEn'],
        'coHsCode': json['coHsCode'] == null ? undefined : json['coHsCode'],
        'combined': json['combined'] == null ? undefined : json['combined'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'initQuantity': json['initQuantity'] == null ? undefined : json['initQuantity'],
        'skuProductId': json['skuProductId'] == null ? undefined : json['skuProductId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'code': json['code'] == null ? undefined : json['code'],
        'purchasePlatformUrl': json['purchasePlatformUrl'] == null ? undefined : json['purchasePlatformUrl'],
        'parentGoodsId': json['parentGoodsId'] == null ? undefined : json['parentGoodsId'],
        'totalPriceCny': json['totalPriceCny'] == null ? undefined : json['totalPriceCny'],
        'ctmsItemId': json['ctmsItemId'] == null ? undefined : json['ctmsItemId'],
        'constructCount': json['constructCount'] == null ? undefined : json['constructCount'],
        'businessPlatformId': json['businessPlatformId'] == null ? undefined : json['businessPlatformId'],
    };
}

export function GoodsInfoForKoreaReturnVoToJSON(json: any): GoodsInfoForKoreaReturnVo {
    return GoodsInfoForKoreaReturnVoToJSONTyped(json, false);
}

export function GoodsInfoForKoreaReturnVoToJSONTyped(value?: GoodsInfoForKoreaReturnVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'skuId': value['skuId'],
        'name': value['name'],
        'unitPrice': value['unitPrice'],
        'totalPriceKrw': value['totalPriceKrw'],
        'totalPriceUsd': value['totalPriceUsd'],
        'url': value['url'],
        'imgUrl': value['imgUrl'],
        'color': value['color'],
        'size': value['size'],
        'origin': value['origin'],
        'brand': value['brand'],
        'marketBarcode': value['marketBarcode'],
        'marketProNm': value['marketProNm'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'marketExpiryDate': value['marketExpiryDate'],
        'coGoodsNameEn': value['coGoodsNameEn'],
        'coHsCode': value['coHsCode'],
        'combined': value['combined'],
        'sourceType': value['sourceType'],
        'initQuantity': value['initQuantity'],
        'skuProductId': value['skuProductId'],
        'userId': value['userId'],
        'code': value['code'],
        'purchasePlatformUrl': value['purchasePlatformUrl'],
        'parentGoodsId': value['parentGoodsId'],
        'totalPriceCny': value['totalPriceCny'],
        'ctmsItemId': value['ctmsItemId'],
        'constructCount': value['constructCount'],
        'businessPlatformId': value['businessPlatformId'],
    };
}

